import { render } from "./TranslationClassification.vue?vue&type=template&id=4c4f0608&scoped=true"
import script from "./TranslationClassification.vue?vue&type=script&lang=js"
export * from "./TranslationClassification.vue?vue&type=script&lang=js"

import "./TranslationClassification.vue?vue&type=style&index=0&id=4c4f0608&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c4f0608"

export default script